module.exports = __webpack_public_path__ + "img/avatar.8ef1f4f5.png";